import { render, staticRenderFns } from "./activityPage.vue?vue&type=template&id=b153ca86&scoped=true&"
import script from "./activityPage.vue?vue&type=script&lang=js&"
export * from "./activityPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b153ca86",
  null
  
)

export default component.exports